import { render, staticRenderFns } from "./GroupForumForums.vue?vue&type=template&id=8882ca62&"
import script from "./GroupForumForums.vue?vue&type=script&lang=js&"
export * from "./GroupForumForums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports